const taskList = (editor) => {

    editor.BlockManager.add('taskList', {
        category: 'List Items',
        label: `
                    <svg  width="1.4vw" height="1.4vw" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path class="gjs-block-svg-path" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"/>
                    <path class="gjs-block-svg-path" d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z"/>
                    <path class="gjs-block-svg-path" fill-rule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"/>
                    </svg>
                    <div class='gjs-fontFamily gjs-block-label'>Task List</div>
                  `,
        attributes: {},
        content: `
        <div class="container py-5">
          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-md-12 col-xl-10">
      
              <div class="card shadow">
                <div class="card-header p-3 bg-light">
                  <h5 class="mb-0"><i class="bi-list-task me-2"></i>Task List</h5>
                </div>
                <div class="card-body">
      
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th scope="col"><strong>Team Member</strong></th>
                        <th scope="col"><strong>Task</strong></th>
                        <th scope="col"><strong>Priority</strong></th>
                        <th scope="col"><strong>Actions</strong></th>
                      </tr>
                    </thead>
                    <tbody dataitems=getAllRows>
                      <tr class="fw-normal" dataitem=true>
                        <td>
                          <img src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359554_640.png"
                            class="shadow-1-strong rounded-circle col-1" alt="avatar 1">
                          <span class="ms-2 fw-bold">Alice Mayer</span>
                        </td>
                        <td class="align-middle">
                          <span>Call Sam For payments</span>
                        </td>
                        <td class="align-middle">
                          <span class="badge bg-danger">High priority</span>
                        </td>
                        <td class="align-middle">
                          <a href="#!" title="Done"><i
                              class="bi-check2 text-success me-3"></i></a>
                          <a href="#!" title="Remove"><i
                              class="bi-trash text-danger"></i></a>
                        </td>
                      </tr>
                      <tr class="fw-normal" dataitem=true>
                        <td>
                          <img src="https://cdn.pixabay.com/photo/2017/03/01/22/18/avatar-2109804_640.png"
                            class="shadow-1-strong rounded-circle col-1" alt="avatar 1">
                          <span class="ms-2 fw-bold">Kate Moss</span>
                        </td>
                        <td class="align-middle"><span>Make payment to Bluedart</span></td>
                        <td class="align-middle">
                          <span class="badge bg-success">Low priority</span>
                        </td>
                        <td class="align-middle">
                          <a href="#!" title="Done"><i
                              class="bi-check2 text-success me-3"></i></a>
                          <a href="#!" title="Remove"><i
                              class="bi-trash text-danger"></i></a>
                        </td>
                      </tr>
                      <tr class="fw-normal" dataitem=true>
                        <td>
                          <img src="https://cdn.pixabay.com/photo/2018/09/15/19/23/avatar-3680134_640.png"
                            class="shadow-1-strong rounded-circle col-1" alt="avatar 1">
                          <span class="ms-2 fw-bold">Danny McChain</span>
                        </td>
                        <td class="align-middle"><span>Office rent</span></td>
                        <td class="align-middle">
                          <span class="badge bg-warning">Middle priority</span>
                        </td>
                        <td class="align-middle">
                          <a href="#!" title="Done"><i
                              class="bi-check2 text-success me-3"></i></a>
                          <a href="#!" title="Remove"><i
                              class="bi-trash text-danger"></i></a>
                        </td>
                      </tr>
                      <tr class="fw-normal" dataitem=true>
                        <td>
                          <img src="https://cdn.pixabay.com/photo/2018/08/28/14/40/avatar-3637701_640.png"
                            class="shadow-1-strong rounded-circle col-1" alt="avatar 1">
                          <span class="ms-2 fw-bold">Alexa Chung</span>
                        </td>
                        <td class="align-middle"><span>Office grocery shopping</span></td>
                        <td class="align-middle">
                          <span class="badge bg-danger">High priority</span>
                        </td>
                        <td class="align-middle">
                          <a href="#!" title="Done"><i
                              class="bi-check2 text-success me-3"></i></a>
                          <a href="#!" title="Remove"><i
                              class="bi-trash text-danger"></i></a>
                        </td>
                      </tr>
                      <tr class="fw-normal" dataitem=true>
                        <td class="">
                          <img src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_640.png"
                            class="shadow-1-strong rounded-circle col-1" alt="avatar 1">
                          <span class="ms-2 fw-bold">Ben Smith</span>
                        </td>
                        <td class="align-middle"><span>Ask for Lunch to Clients</span></td>
                        <td class="align-middle">
                          <span class="badge bg-success">Low priority</span>
                        </td>
                        <td class="align-middle">
                          <a href="#!" title="Done"><i
                              class="bi-check2 text-success me-3"></i></a>
                          <a href="#!" title="Remove"><i
                              class="bi-trash text-danger"></i></a>
                        </td>
                      </tr>
                      <tr class="fw-normal" dataitem=true>
                        <td class="border-0">
                          <img src="https://cdn.pixabay.com/photo/2016/03/31/19/58/avatar-1295430_640.png"
                            class="shadow-1-strong rounded-circle col-1" alt="avatar 1">
                          <span class="ms-2 fw-bold">Annie Hall</span>
                        </td>
                        <td class="border-0 align-middle"><span>Create weekly tasks plan</span></td>
                        <td class="border-0 align-middle">
                          <span class="badge bg-warning">Medium priority</span>
                        </td>
                        <td class="border-0 align-middle">
                          <a href="#!" title="Done"><i
                              class="bi-check2 text-success me-3"></i></a>
                          <a href="#!" title="Remove"><i
                              class="bi-trash text-danger"></i></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
      
                </div>
                <div class="card-footer text-end p-3">
                  <button class="btn btn-primary shadow">Add Task</button>
                </div>
              </div>
      
            </div>
          </div>
        </div>
        `
    })
};

export default taskList;